// @flow
import * as React from 'react';
import Avatar from 'components/Avatar';
import Field from 'components/Field';
import Label from 'components/Label';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';

type Props = {
  orgName: string,
  onMount: () => void,
};

export default class AdminNewAutoMessageComposeDistrictSender extends React.PureComponent<Props> {
  componentDidMount() {
    this.props.onMount();
  }

  render() {
    return (
      <Field>
        <Label>Sender</Label>
        <MediaObject gutter="small">
          <Avatar
            image="https://remind.imgix.net/0b34f158-c3d0-4321-8cd7-aa6ec744e6d6/school.svg"
            size="small"
          />
          <Text size="xsmall" element="div">
            <Text element="div" weight="semibold">
              {this.props.orgName}
            </Text>
            <Text color="thunder">
              Messages at the district level must be sent from the district, and recipients won’t be
              able to reply to this message.
            </Text>
          </Text>
        </MediaObject>
      </Field>
    );
  }
}
